import { useEffect } from 'react';

// Custom hook for performance monitoring
const usePerformanceMetrics = (componentName) => {
  useEffect(() => {
    // Web Vitals measurement
    if ('web-vitals' in window) {
      return;
    }

    // Performance observer for paint metrics
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (entry.entryType === 'paint') {
            console.log(`${componentName} - ${entry.name}: ${entry.startTime}ms`);
          }
        });
      });

      observer.observe({ entryTypes: ['paint', 'navigation'] });

      return () => observer.disconnect();
    }
  }, [componentName]);

  // Report long tasks
  useEffect(() => {
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (entry.duration > 50) {
            console.warn(`${componentName} - Long task detected: ${entry.duration}ms`);
          }
        });
      });

      observer.observe({ entryTypes: ['longtask'] });

      return () => observer.disconnect();
    }
  }, [componentName]);
};

export default usePerformanceMetrics;